import { useEffect, useState } from "react";
import { Button, Header, Icon, Label, List, Table } from "semantic-ui-react";
import moment from "moment";

const Invoice = (props) => {
  const {
    selectedJob,
    getStatus,
    servicesList,
    serviceTotal,
    setServiceTotal,
    isCSR,
    isAttorney,
  } = props;
  const [totalsArray, setTotalsArray] = useState([]);
  const [serviceItems, setServiceItems] = useState([]);
  const invoiceObj = selectedJob.invoice ? JSON.parse(selectedJob.invoice) : "";

  useEffect(() => {
    console.log(totalsArray);
  }, [totalsArray]);

  useEffect(() => {
    getServiceTotal();
  }, [totalsArray]);

  useEffect(() => {
    handleRenderServices();
    console.log("servicesList", servicesList, "serviceTotal", serviceTotal);
  }, [servicesList, selectedJob, serviceTotal]);

  const Bullet = (obj) => {
    return (
      <div
        style={{
          height: "20px",
          width: "20px",
          borderRadius: "20px",
          backgroundColor: "#888888",
          color: "#FFFFFF",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontWeight: 900,
        }}
      >
        {obj.number}
      </div>
    );
  };

  const TranscriptStatus = (obj) => {
    return (
      <Label
        basic
        size="large"
        content={obj.path ? "Uploaded" : "Not Uploaded"}
        color={obj.path ? "green" : "red"}
      />
    );
  };

  const ServiceStatus = (obj) => {
    return (
      <Label
        basic
        size="large"
        content={obj.path ? "Provided" : "Not Provided"}
        color={obj.path ? "green" : "red"}
      />
    );
  };

  const getTranscriptTotal = (format, amount, rate, markup) => {
    const subtotal = amount * rate;
    const fee = subtotal * (markup * 0.01);
    const total = subtotal + fee;
    if (format === "raw") {
      return total;
    } else {
      return formatUSD(total);
    }
  };

  const formatUSD = (amount) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  };

  const formatCurrency = (amountStr) => {
    const amount = parseFloat(amountStr); // Convert string to number
    if (isNaN(amount)) return "Invalid number"; // Handle invalid input
    const newAmount = amount / 100;
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(newAmount);
  };

  const getInvoiceStatus = (status) => {
    return (
      <Label
        basic
        content={status.toUpperCase()}
        color={
          status === "open"
            ? "blue"
            : status === "paid"
            ? "green"
            : status === "void"
            ? "red"
            : "grey"
        }
      />
    );
  };

  const getNameReplacement = (name) => {
    if (name === "bill_appearanceFee") return "Appearance Fee";
    if (name === "bill_hourlyRate") return "Hourly Rate";
    if (name === "bill_takeDownNoWrite") return "Take Down / No Write";
    if (name === "bill_waitTime") return "Wait Time";
    if (name === "bill_afterHours") return "After Hours";
    if (name === "bill_cancellationFee") return "Cancellation Fee";
    if (name === "bill_medicalExpert") return "Medical Expert";
    if (name === "bill_hearingsArbitrations") return "Hearings / Arbitrations";
    if (name === "bill_trials") return "Trials";
    if (name === "bill_videoTaped") return "Video Taped";
    if (name === "bill_audioTranscript") return "Audio Transcript";
    if (name === "bill_realtime") return "Realtime Transcript";
    if (name === "bill_cart") return "CART";
    if (name === "bill_roughDraft") return "Rough Draft";
    if (name === "bill_etran") return "ETran";
    if (name === "bill_provideConferenceRoom") return "Conference Room";
    if (name === "bill_provideVideoConference") return "Video Conference";
    if (name === "bill_remoteServices") return "Remote Services";
    if (name === "bill_additionalLaptop") return "Additional Laptop";
    if (name === "bill_additionalTablet") return "Additional Tablet";
    if (name === "bill_originalTranscriptPlusOneCopy")
      return "Original Transcript (1 Copy)";
    if (name === "bill_indexFee") return "Index Fee";
    if (name === "bill_minimumOriginalTranscriptFee")
      return "Minimum Original Transcript Fee";
    if (name === "bill_copyTranscript") return "Additional Copy";
    if (name === "bill_exhibitCopyBlackAndWhite")
      return "Exhibit Copy (Black & White)";
    if (name === "bill_exhibitCopyColor") return "Exhibit Copy (Color)";
    if (name === "bill_vtcSurcharge") return "VTC Surcharge";
    if (name === "bill_sameDateExpedite") return "Same Day Expedite";
    if (name === "bill_oneDayExpedite") return "1 Day Expedite";
    if (name === "bill_twoDayExpedite") return "2 Day Expedite";
    if (name === "bill_threeDayExpedite") return "3 Day Expedite";
    if (name === "bill_fourDayExpedite") return "4 Day Expedite";
    if (name === "bill_fiveDayExpedite") return "5 Day Expedite";
    if (name === "bill_sixDayExpedite") return "6 Day Expedite";
    if (name === "bill_sevenDayExpedite") return "7 Day Expedite";
    if (name === "bill_eightDayExpedite") return "8 Day Expedite";
    if (name === "bill_certificateOfNonappearance")
      return "Certificate of Non-Appearance";
    if (name === "bill_courthouseHalfDay") return "Court House - Half Day";
    if (name === "bill_courthouseFullDay") return "Court House - Full Day";
    if (name === "bill_courthouseHourly") return "Court House - Hourly";
    if (name === "bill_notaryPublic") return "Notary Public";
    if (name === "bill_deliveryHandling") return "Delivery Shipping/Handling";
    if (name === "bill_mileage") return "Mileage";
    if (name === "bill_videographerFee") return "Videographer - Initial Fee";
    if (name === "bill_videographerHourly") return "Videographer - Hourly";
  };

  const getMath = (serviceName, multiplier) => {
    let serviceMultiple = multiplier;
    if (multiplier === true) serviceMultiple = 1;
    const trimmedName = serviceName.replace(/^bill_/, "");
    const serviceRate = servicesList[trimmedName];
    console.log(trimmedName, serviceMultiple, "x", serviceRate);
    return `${formatUSD(serviceRate)} x ${serviceMultiple} = ${formatUSD(
      serviceRate * serviceMultiple
    )}`;
  };

  const getTotal = (multiple, rate) => {
    return multiple * rate;
  };

  const getServiceRate = (serviceName) => {
    const trimmedName = serviceName.replace(/^bill_/, "");
    const serviceRate = servicesList[trimmedName];
    return serviceRate;
  };

  const getServiceTotal = () => {
    const total = totalsArray.reduce((sum, num) => sum + num, 0); // Sum all amounts
    const markedUpTotal = total * 1.18; // Apply 18% markup
    setServiceTotal(markedUpTotal.toFixed(2));
  };

  const handleRenderServices = () => {
    const mappedArray = Object.entries(selectedJob).map(([key, value]) => {
      return { name: key, value };
    });
    const filteredArray = mappedArray.filter(
      (x) => x.name.includes("bill_") && x.value
    );
    let array = [];
    let totalArray = [];
    for (const f of filteredArray) {
      const obj = {
        name: getNameReplacement(f.name),
        text: getMath(f.name, f.value),
        multiplier: f.value,
        rate: getServiceRate(f.name),
      };
      array.push(obj);
      totalArray.push(getTotal(f.value, getServiceRate(f.name)));
    }
    setTotalsArray(totalArray);
    setServiceItems(array);
  };

  const ServiceItems = () => {
    return serviceItems.map((item, index) => {
      return (
        <List.Item key={index}>
          {item.name}: {item.text}
        </List.Item>
      );
    });
  };

  return (
    <div>
      {!isAttorney && (
        <Header
          content="Complete the checklist before generating an invoice."
          subheader="In order to generate an invoice to send to the Attorney/Law Firm, the job must be marked as Completed, the Job Order Form and Transcript file must be uploaded, and any/all services rendered must be added. Once an invoice is finalized it cannot be changed."
        />
      )}
      <Table basic>
        {!isAttorney && (
          <Table.Row>
            <Table.Cell>
              <Bullet number={"1"} />
            </Table.Cell>
            <Table.Cell>
              <Header style={{ margin: "0px" }} content="Job Status:" />
            </Table.Cell>
            <Table.Cell>{getStatus(selectedJob.status, true)}</Table.Cell>
            <Table.Cell>
              <Icon
                name={selectedJob.status === "Completed" ? "check" : "close"}
                color={selectedJob.status === "Completed" ? "green" : "red"}
              />
            </Table.Cell>
          </Table.Row>
        )}
        {!isAttorney && (
          <Table.Row>
            <Table.Cell>
              <Bullet number={"2"} />
            </Table.Cell>
            <Table.Cell>
              <Header style={{ margin: "0px" }} content="Order Form:" />
            </Table.Cell>
            <Table.Cell>
              <TranscriptStatus path={selectedJob.orderForm ? true : false} />
            </Table.Cell>
            <Table.Cell>
              <Icon
                name={selectedJob.orderForm ? "check" : "close"}
                color={selectedJob.orderForm ? "green" : "red"}
              />
            </Table.Cell>
          </Table.Row>
        )}
        <Table.Row>
          {!isAttorney && (
            <Table.Cell>
              <Bullet number={"3"} />
            </Table.Cell>
          )}
          <Table.Cell>
            <Header style={{ margin: "0px" }} content="Transcript:" />
          </Table.Cell>
          <Table.Cell>
            <TranscriptStatus path={selectedJob.transcriptPdf ? true : false} />
          </Table.Cell>
          <Table.Cell>
            <Icon
              name={selectedJob.transcriptPdf ? "check" : "close"}
              color={selectedJob.transcriptPdf ? "green" : "red"}
            />
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          {!isAttorney && (
            <Table.Cell>
              <Bullet number={"4"} />
            </Table.Cell>
          )}
          <Table.Cell>
            <Header style={{ margin: "0px" }} content="Service Details:" />
            <List bulleted>
              <ServiceItems />
              <List.Item>Stenexus Fee: 18%</List.Item>
            </List>
            <div>
              {" "}
              Service Total:{" "}
              <span style={{ fontWeight: 900 }}>
                {new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                }).format(serviceTotal)}
              </span>
            </div>
          </Table.Cell>
          <Table.Cell>
            <ServiceStatus path={serviceTotal > 0 ? true : false} />
          </Table.Cell>
          <Table.Cell>
            <Icon
              name={serviceTotal > 0 ? "check" : "close"}
              color={serviceTotal > 0 ? "green" : "red"}
            />
          </Table.Cell>
        </Table.Row>
        {selectedJob.invoiceId && (
          <Table.Row>
            {!isAttorney && <Table.Cell></Table.Cell>}
            <Table.Cell>
              <Header style={{ margin: "0px" }} content="Invoice Details:" />
              <List bulleted>
                <List.Item>
                  <span style={{ fontWeight: 900 }}>Status:</span>{" "}
                  {getInvoiceStatus(invoiceObj.status)}
                </List.Item>
                <List.Item>
                  <span style={{ fontWeight: 900 }}>Due:</span>{" "}
                  {moment.unix(invoiceObj.due_date).format("LL")}
                </List.Item>
                <List.Item>
                  <span style={{ fontWeight: 900 }}>Amount Due:</span>{" "}
                  {formatCurrency(invoiceObj.amount_due)}
                </List.Item>
                <List.Item>
                  <span style={{ fontWeight: 900 }}>Amount Paid:</span>{" "}
                  {formatCurrency(invoiceObj.amount_paid)}
                </List.Item>
              </List>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <a href={invoiceObj.invoice_pdf}>
                  <Button
                    size="large"
                    primary
                    icon="download"
                    content="Download PDF"
                  />
                </a>
                {!isCSR && (
                  <a target="blank" href={invoiceObj.hosted_invoice_url}>
                    <Button
                      size="large"
                      positive
                      icon="dollar"
                      content="Pay Now"
                    />
                  </a>
                )}
              </div>
            </Table.Cell>
            <Table.Cell></Table.Cell>
            <Table.Cell></Table.Cell>
          </Table.Row>
        )}
      </Table>
    </div>
  );
};
export default Invoice;
